import React, { Suspense } from 'react'; // Tambahkan import Suspense
import { AnimatePresence } from 'framer-motion';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AllRoutes } from './index';
import Loader from '../components/Loader'; // Pastikan path Loader sesuai

const Routes = () => {
    return (
        <HelmetProvider>
            <BrowserRouter>
                <Suspense fallback={<Loader />}> 
                    <AnimatePresence>
                        <AllRoutes />
                    </AnimatePresence>
                </Suspense>
            </BrowserRouter>
        </HelmetProvider>
    );
};

export default Routes;
